import { openEventStream } from './sse';

/**
 * SSE stream to the module-builder agent. Event handlers map 1:1 to the
 * server-side event types in ai/module_builder/loop.py; the transport,
 * including CSRF and abort handling, lives in `openEventStream`.
 */
export const streamModuleBuilder = async ({
  messages,
  formState,
  annotations,
  lastTestResult,
  signal,
  onText,
  onThinking,
  onToolUseStart,
  onToolResult,
  onModuleUpdate,
  onTestResult,
  onDone,
  onError,
}) =>
  openEventStream({
    path: '/v1/custom_models/ai_chat/',
    logLabel: 'ModuleBuilder SSE',
    signal,
    onDone,
    onError,
    body: {
      messages,
      form_state: formState ?? {},
      annotations: annotations ?? {},
      last_test_result: lastTestResult ?? null,
    },
    onEvent: event => {
      switch (event.type) {
        case 'text':
          onText?.(event.content ?? '');
          break;
        case 'thinking':
          onThinking?.(event.content ?? '');
          break;
        case 'tool_use_start':
          onToolUseStart?.({ id: event.id, name: event.name, input: event.input });
          break;
        case 'tool_result':
          onToolResult?.({ id: event.id, result: event.result });
          break;
        case 'module_update':
          onModuleUpdate?.(event.partial ?? {});
          break;
        case 'test_result':
          onTestResult?.(event.result);
          break;
        default:
          // Ignore unrecognized event types.
          break;
      }
    },
  });
